import styled from '@emotion/styled';

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
